import { initScrollClasses, initModal, initAfterInteract, initVideoMoals, autoplayVideosObserver } from "./functions/core";
import { initDatalayer, readCookiePermissions, readCookie } from "./functions/cookies/core";
import { validateFormBootstrap } from "./functions/forms/validation";
import { initMobileMenuDropdown } from "./functions/mobile-menu-dropdown";
import { initPublicationsFilters } from "./functions/publications-filters";

import { initJquery } from "./functions/initializers/jquery";
import { initSelect2 } from "./functions/initializers/select2";
import { initDatepicker } from "./functions/initializers/datepicker";
import { toggleCollapseOnParent } from "./functions/initializers/parent-collapse";
import { initTimepicker } from "./functions/initializers/timepicker";
import { initSwiper } from "./functions/initializers/swiper";
import { initQuickUseGuideSwiper } from "./functions/initializers/quick-use-guide-swiper";
import { initMarquee } from "./functions/initializers/marquee";
import { initFileInput } from "./functions/initializers/file-input";
import { initCookiesBox } from "./functions/initializers/cookie-box";
import { initBootstrap } from "./functions/initializers/bootstrap";
import { initBlobBackground } from "./functions/initializers/blob-background";
import { initGsap } from "./functions/initializers/gsap";
import { initWiseMetricsTabs } from "./functions/initializers/wise-metrics-tabs";
import { initQuiz } from "./functions/initializers/quiz";
import { initViewer } from "./functions/initializers/viewer";

// Add functions to the global window object to give access to backend devs
document.addEventListener("DOMContentLoaded", async () => {
	console.log("Developed by LOBA - https://www.loba.com/");

	//=== Core ===//

	initScrollClasses('.header')
	window.initModal = initModal;

	//=== Mobile Menu ===//

	initMobileMenuDropdown();

	//=== Publications Filters ===//

	initPublicationsFilters();

	//=== Cookies ===//

	initDatalayer()
	readCookiePermissions('loba_')
	window.readCookie = readCookie;
	window.initCookiesBox = initCookiesBox;

	Promise.all([
		// Swiper
		initSwiper('.swiper-from-dataset'),
		// Quick Use Guide Swiper
		initQuickUseGuideSwiper(),
		// Custom Marquee
		initMarquee('.marquee'),
		// Allow collapse to toggle a classe on any parent element
		toggleCollapseOnParent(),
		//=== Bootstrap ===//
		initBootstrap({
			'critical': ["initCollapse"] // Collapse is critical for the menu, everything else can be lazy loaded in most cases
		}),
		// Blob Background
		initBlobBackground(),
		// GSAP Particle Morphing
		initGsap('.hero,.particle-morph,.image-text-columns__image,.timeline,.bubble-diagram'),
		// Autoplay videos when visible
		autoplayVideosObserver(`video[data-js-autoplay="true"]`),
		// Quiz
		initQuiz('.quiz')
	]).then(() => {
		window.initDatepicker = initDatepicker
	})

	//=== Non-Critical Functions ===//

	Promise.all([
		initAfterInteract([
			// Datepicker
			() => initDatepicker('.datepicker-input'),
			// Timepicker
			() => initTimepicker('.timepicker-input'),
			// File Input
			() => initFileInput(".custom-file input"),
			// Video Modals
			() => initVideoMoals('[data-video-src]'),
			// Viewerjs
			() => initViewer('[data-viewer]'),
		])
	]).then(() => {
		window.initTimepicker = initTimepicker
		window.initFileInput = initFileInput;
	})

	//=== Forms ===//

	validateFormBootstrap(".needs-validation")

});


initJquery().then(() => {
	function runWhenDOMReady() {
		// jQuery dependant code should be placed here

		//=== Select2 ===//
		initSelect2('.custom-select-option select')
		window.initSelect2 = initSelect2;

		// WISE Metrics Tabs
		initWiseMetricsTabs()
	}

	if (document.readyState === 'interactive' || document.readyState === 'complete') { runWhenDOMReady(); } else { document.addEventListener('DOMContentLoaded', runWhenDOMReady); }
})